import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import filterReducer from "./filterSlice"; // ✅ Import new reducer

const store = configureStore({
  reducer: {
    cart: cartReducer,
    filter: filterReducer, // ✅ Add to store
  },
});

export default store;